const data = {
  //todo: server should replace _ with -
  locale: "el-GR",
  servicesBaseUrl: "/api/",
  svgBasePath: "/ext_files/app/",
  imgBasePath: "/ext_files/app/images/",
  siteUrl: "https://www.vodafone.gr/",
  cdnUrl: "https://d379ltrup2xoki.cloudfront.net/",

  googleApi: {
    basePath: "https://maps.googleapis.com/maps/api/js",
    key: "AIzaSyAyesbQMyKVVbBgKVi2g6VX7mop2z96jBo",
    version: 3
  },

  translations: {
    genericServerError: "Χμμμ, κάτι πήγε στραβά...",
    overlayLoaderMessage: "Παρακαλούμε, περίμενε",
    confirmDialog_cancel: "Ακύρωση",
    confirmDialog_ok: "OK",
    childMessage: "Δεν μπορείς να δεις αυτή τη σελίδα",
    dxlErrorMessage:
      "Λυπούμαστε πολύ. Η online υπηρεσία βρίσκεται <strong>υπό τεχνική αναβάθμιση</strong>. Παρακαλούμε πολύ, δοκίμασε αργότερα ή μπορείς να επικοινωνήσεις μαζί μας μέσω <a target='_blank' href='https://www.vodafone.gr/live-chat/'><u>live chat</u></a>.",
    dxlAuthErrorMessage:
      "Η υπηρεσία δεν μπόρεσε να ανταποκριθεί. Παρακαλούμε, δοκίμασε να αποσυνδεθείς από το My Account και να συνδεθείς ξανά ώστε η υπηρεσία να είναι προσβάσιμη.",
    dxlGenericTransactionError:
      "Λυπούμαστε πολύ. Η ολοκλήρωση της διαδικασίας δεν είναι εφικτή.",
    copyright: "© {year} Vodafone Group"
  },

  formValidationErrorMessages: {
    isNotEmpty: "Παρακαλούμε, συμπλήρωσε το πεδίο",
    isOptionSelected: "Παρακαλούμε, κάνε μια επιλογή",
    isNumeric: "Παρακαλούμε, συμπλήρωσε το πεδίο μόνο με αριθμούς",
    isExactLength_Chars:
      "Παρακαλούμε, συμπλήρωσε στο πεδίο ακριβώς {length} χαρακτήρες",
    isExactLength_Digits:
      "Παρακαλούμε, συμπλήρωσε στο πεδίο τα {length} ψηφία του αριθμού",
    isPhone: "Παρακαλούμε, συμπλήρωσε έναν έγκυρο αριθμό τηλεφώνου",
    isMobile: "Παρακαλούμε, συμπλήρωσε έναν έγκυρο αριθμό κινητού",
    isEmail: "Παρακαλούμε, συμπλήρωσε ένα έγκυρο e-mail",
    isAmount: "Παρακαλούμε, συμπλήρωσε ένα έγκυρο ποσό",
    isNotZero_Amount: "Το ποσό θα πρέπει να είναι μεγαλύτερο από μηδέν",
    isNotZero_Value: "Η τιμή θα πρέπει να είναι μεγαλύτερή από μηδέν",
    isChecked: "Παρακαλούμε, επίλεξε το παρακάτω πεδίο",
    isAfm: "Παρακαλούμε, συμπλήρωσε έναν έγκυρο Α.Φ.Μ.",
    isFixed: "Συμπλήρωσε έναν έγκυρο αριθμό σταθερού τηλεφώνου",
    or: " ή ",
    default: "Το πεδίο δεν είναι έκγυρο"
  },

  // todo: changing language for global data should be handled in a more generic and scalable way
  // todo: make sure data is correct in wcs
  formValidationErrorMessages_en: {
    isNotEmpty: "Please fill in the field",
    isOptionSelected: "Please select an option",
    isNumeric: "Please use only numbers",
    isExactLength_Chars: "Please fill in exactly {length} characters",
    isExactLength_Digits: "Please fill in the {length} digits of the number",
    isPhone: "Please fill in a valid phone number",
    isMobile: "Please fill in a valid mobile number",
    isEmail: "Please fill in a valid e-mail",
    isAmount: "Please fill in a valid amount",
    isNotZero_Amount: "The amount should be greater than 0",
    isNotZero_Value: "The value should be greater than 0",
    isChecked: "Please check the following option",
    isAfm: "Please fill in a valid tax number",
    isFixed: "Please fill in a valid landline phone",
    or: " or ",
    default: "The field is invalid"
  },

  // Handle all backend services in one global method.
  services: {
    systemAvailability: {
      url: "global/systemAvailability",
      params: {}
    },
    translations: {
      url: "global/translations",
      params: {}
    },
    getUserInfo: {
      url: "global/getUserInfo",
      params: {}
    },
    getUserStatus: {
      url: "global/getUserStatus",
      params: {}
    },
    generateCaptcha: {
      url: "global/generateCaptcha",
      params: {}
    }
  },

  payments: {
    bankPostUrl: "/api/bank-page",
    bankPopupUrl: "/ext_files/bank/postData.html",
    termsUrl: "/test-pages/terms.html",
    topupTermsUrl: "/test-pages/terms.html",
    translations: {
      genericErrorTitle: "Χμμμ, κάτι πήγε στραβά...",
      genericErrorSubtitle:
        "Λόγω τεχνικού προβλήματος δεν μπορούμε να πραγματοποιήσουμε πληρωμές. Παρακαλούμε προσπάθησε αργότερα.",
      overlayTextBank:
        "Έχεις επιλέξει να παραγματοποιήσεις πληρωμή μέσω του ασφαλούς περιβάλλοντος πληρωμής της Alpha Bank.<br>Αν δεν μπορείς να δεις το παράθυρο",
      overlayTextPaypal:
        "Έχεις επιλέξει να παραγματοποιήσεις πληρωμή μέσω του ασφαλούς περιβάλλοντος πληρωμής του PayPal.<br>Αν δεν μπορείς να δεις το παράθυρο",
      overlayBtnText: "κάνε κλικ εδώ"
    },
    services: {
      translations: {
        url: "payments/translations",
        params: {}
      },
      getOptions: {
        url: "payments/getOptions",
        params: {}
      },
      generateDigest: {
        url: "payments/generateDigest",
        params: {}
      },
      braintreeToken: {
        url: "payments/braintreeToken",
        params: {}
      },
      braintreeCheckout: {
        url: "payments/braintreeCheckout",
        params: {}
      },
      sendEmail: {
        url: "payments/sendEmail",
        params: {}
      },
      getInstallments: {
        url: "payments/getInstallments",
        params: {}
      },
      deleteCard: {
        url: "payments/deleteCard",
        params: {}
      }
    },
    paymentHistory: {
      C1: "Πληρωμή σε Τράπεζα",
      C4: "Πληρωμή στα ΕΛΤΑ",
      C5: "Πληρωμή σε κατάστημα Vodafone",
      CH: "Πληρωμή σε Ταμείο Vodafone",
      CB: "Πληρωμή σε Τράπεζα",
      CP: "Πληρωμή σε Τράπεζα",
      CD: "Πληρωμή στα ΕΛΤΑ",
      CE: "Πληρωμή στα ΕΛΤΑ",
      CF: "Πληρωμή στα ΕΛΤΑ",
      CA: "Πληρωμή σε ΑΤΜ",
      DB: "Πληρωμή με Πάγια Τραπεζική Εντολή",
      CQ: "Πληρωμή με Επιταγή",
      NL: "Πληρωμή με Μετρητά",
      CR: "Ακύρωση Επιταγής",
      MR: "Ακύρωση Πληρωμής",
      RD: "Απόρριψη Πάγιας Τραπεζικής Πληρωμής",
      PR: "Vodafone Cashback – Επιστροφή Χρημάτων",
      RC: "Απόρριψη Αυτόματης Πληρωμής",
      RM: "Απόρριψη Αυτόματης Πληρωμής",
      SF: "Πληρωμή Τέλους Φορητότητας",
      PZ: "Πληρωμή με Μετρητά",
      RE: "Ακύρωση Πληρωμής",
      CI: "Πληρωμή με Πιστωτική κάρτα",
      DC: "Αυτόματη πληρωμή με Κάρτα",
      SP: "Πληρωμή σε κατάστημα Vodafone",
      CV: "Επιδότηση δράσης «εύρυ-where»",
      CT: "Πληρωμή με Κάρτα",
      CM: "Πληρωμή με Κάρτα",
      BC: "Απλήρωτη Eπιταγή",
      C2: "Πληρωμή μέσω του www.vodafone.gr/My Vodafone app",
      CW:
        "Πληρωμή με Πιστωτική/χρεωστική κάρτα μέσω του www.vodafone.gr/My Vodafone app",
      CX:
        "Πληρωμή με Πιστωτική/χρεωστική κάρτα μέσω του www.vodafone.gr/My Vodafone app",
      SB: "Εξαργύρωση πόντων Alpha Bonus για πληρωμή λογαριασμού",
      PP: "Πληρωμή με PayPal μέσω του www.vodafone.gr/My Vodafone app",
      CY: "Επιδότηση δράσης «εύρυ-where» (συμπ. Φ.Π.Α.)",
      AB: "Εξαργύρωση Alpha Bonus",
      BB: 'Εφάπαξ επιδότηση δράσης "Superfast Broadband"',
      BD: 'Μηνιαία επιδότηση δράσης "Superfast Broadband"',
      BE: 'Εφάπαξ επιδότηση δράσης "Superfast Broadband"',
      BF: 'Μηνιαία επιδότηση δράσης "Superfast Broadband"',
      SW: "Εξαργύρωση πόντων Alpha Bonus για πληρωμή λογαριασμού",
      SR: "Εξαργύρωση πόντων Alpha Bonus μέσω Vodafone Self Service Kiosk",
      PC:
        "Πληρωμή με πιστωτική/χρεωστική κάρτα μέσω του Vodafone Self Service Kiosk",
      CU: "Επιδότηση δράσης «εύρυ-where»",
      CO: "Επιδότηση δράσης «εύρυ-where»",
      QIC: "Πίστωση δόσεων εξοπλισμού Vodafone TV",
      VE: "Πιστωτικό Τιμολόγιο από Ιδιωτικό Συμφωνητικό",
      VC: "Πιστωτικό Τιμολόγιο Παροχής Υπηρεσιών",
      TP: "Τακτοποίηση Λογαριασμού",
      Q3: "Πιστωτικό Τιμολόγιο",
      PT: "Επιστροφή ποσού",
      DR: "Μετατροπή Εγγύησης",
      CK: "Πίστωση πελάτη",
      BA: "Εξαργύρωση πόντων Alpha Bonus",
      PG: "Πληρωμή με Apple/Google Pay"
    },
    mobileTaxPercentage: 12,
    topupOptions: [1000, 1200, 1500, 2000, 3000]
  },

  otp: {
    services: {
      sendSms: {
        url: "OTP/sendSms",
        params: {}
      },
      validateCode: {
        url: "OTP/validateCode",
        params: {}
      },
      clearOtpSession: {
        url: "OTP/clearOtpSession",
        params: {}
      },
      translations: {
        url: "OTP/translations",
        params: {}
      },
      status: {
        url: "OTP/status",
        params: {}
      }
    }
  },

  deviceInstallments: {
    services: {
      translations: {
        url: "deviceInstallments/translations",
        params: {}
      },
      deactivateDeviceInstallments: {
        url: "deviceInstallments/deactivateDeviceInstallments",
        params: {}
      },
      activateDeviceInstallments: {
        url: "deviceInstallments/activateDeviceInstallments",
        params: {
          token:
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI2OTQ0MTQxMjU3IiwiaXNzIjoiRFhMIiwidXNlclJvbGUiOiJQb3N0cGF5Iiwic2lsZW50UmVnaXN0cmF0aW9uIjoiIiwicmVmcmVzaF90b2tlbl9leHBpcmVzIjoxNjUxODI1MDk5LCJleHAiOjE2MjEwNjY2OTksImN1c3RvbWVyVGF4TnVtYmVyIjoiMTU3MzgzMTYyIiwiY3VzdG9tZXJJbmZvIjp7Im1vYmlsZUNSTUN1c3REYXRhIjp7ImN1c3RvbWVyTmFtZSI6Is6SzpHOoc6SzpHOoc6RzqMgzqfOoc6XzqPOpM6fzqMgzqPOoM6lzqHOmc6UzqnOnSIsImN1c3RTZWdtZW50IjoiUkVUQUlMIiwidmFsdWVTZWdtZW50IjoiTWVkaXVtIiwiY3VzdFR5cGUiOiJDT05TVU1FUiIsImZyZWVsYW5jZXJGbGFnIjpmYWxzZSwiY3VzdG9tZXJDb21ib0ZsYWciOmZhbHNlfX0sInByaW1hcnlNc2lzZG4iOiI2OTQ0MTQxMjU3IiwibW9iaWxlQWNjb3VudElkcyI6W3siaWQiOiIxOTAwODY0IiwiYXNzZXRzIjpbeyJhc3NldCI6IjY5NDQxNDEyNTciLCJjb250cmFjdFR5cGUiOiJQb3N0UGF5In1dfV0sInVzciI6IjY5NDQxNDEyNTcifQ.YQQvN8x8i708ZCI-2qbBozM9sygHlRLhuwkYqnc_zpGkRvnNbxvdsujKPjXkgD2EsBB-3M8Rtq0-ZvL_xqceo2Hk3eAnVZ69gr9TqXiZiSZ8dagdvTS6iNnkPM0JeNRQnw0T6GaRZF6TvZWEdEfFRAIuu3unAqy8zR7wHucvE1dp8LXK98NgZPGcHZ64SeFfPvJrh_h7Q_3i5UuaEnDSngfWoFUjmI555WXy2UYLcsYaAxAm1v2LK-wixe7H_DQoQk-MmkhW7j-FNv2OobftNX4ehdpRf3rzpVLiPlRy8DHa-xaWuHfgZelzZs-mLeoR6QC9kdRs7LffbAzhI717fA"
        }
      },
      getDeviceInstallmentsData: {
        url: "deviceInstallments/getDeviceInstallmentsData",
        params: {}
      }
    }
  },

  braintreedropin: {
    services: {
      translations: {
        url: "BraintreeDropIn/translations",
        params: {}
      },
      getToken: {
        url: "BraintreeDropIn/getToken",
        params: {}
      },
      checkout: {
        url: "BraintreeDropIn/checkout",
        params: {}
      }
    }
  }
};

exports.data = data;
